module.exports = __webpack_public_path__ + "media/images/vp/sample.practice3-e7e34beb95dad64b186cbdcfad2b52aa.jpg";